import { Component, OnInit, computed, signal, Signal } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { Place } from 'src/app/interfaces/interfaces';
import { ApiService } from 'src/app/services/api-services/api.service';
import { StringInfoMessageService } from 'src/app/services/string-info-message/string-info-message.service';
import { WebSocketService } from 'src/app/services/web-socket.service';
import { PlacesStore } from 'src/app/stores/places.store';

@Component({
  selector: 'app-add-favorite-places',
  templateUrl: './add-favorite-places.component.html',
  styleUrls: ['./add-favorite-places.component.scss'],
})
export class AddFavoritePlacesComponent implements OnInit {

  // Local search query signal
  private _searchQuerySignal = signal<string>('');
  
  // Computed signal for filtered not favorite places
  public filteredNotFavoritePlaces: Signal<Place[]> = computed(() => {
    const allNotFavoritePlaces = this.placesStore.notFavoritePlaces();
    const searchQuery = this._searchQuerySignal();
    
    return allNotFavoritePlaces.filter(place => this.placesStore.findMatchingPlaces(place, searchQuery));
  });

  constructor(
  public stringInfoMessageService:StringInfoMessageService,
  public placesStore:PlacesStore

  ) { }

  ngOnInit() {

  }


  filterPlaces(query = '') {
    this._searchQuerySignal.set(query);
  }
  
}
